module.exports = "/public/images/4bc0547697f581b36e5c56e3fe88f7be.png";